import React from 'react';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import Hero from './components/Hero';
import Welcome from './components/Welcome';
import Program from './components/Program';
import RSVPForm from './components/RSVPForm';
import Footer from './components/Footer';
import Gifts from './components/Gifts';
import DressCode from './components/DressCode';
import EventDetails from './components/EventDetails'; 

// FONTOS: Be kell importálni a CSS-t, ahol a @font-face szabályok vannak!
import './index.css'; 

// Textúra kép beimportálása
// @ts-ignore
import textureBg from './videos/texture.png'; 

// A Heritage Téma létrehozása
const theme = createTheme({
  palette: {
    background: {
      default: '#ffffff', 
      paper: '#ffffff',   
    },
    primary: {
      main: '#002D62', 
      dark: '#001A3F', 
    },
    text: {
      primary: '#333333', 
      secondary: '#FFD700', 
    },
  },
  typography: {
    fontFamily: '"Blosta", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"AMORESA", serif', fontWeight: 400 },
    h2: { fontFamily: '"AMORESA", serif', fontWeight: 400 },
    h3: { fontFamily: '"AMORESA", serif', fontWeight: 400 },
    h4: { fontFamily: '"AMORESA", serif', fontWeight: 400 },
    h5: { fontFamily: '"Blosta", sans-serif', fontWeight: 400 },
    h6: { fontFamily: '"Blosta", sans-serif', fontWeight: 400, letterSpacing: 2 },
    body1: { fontFamily: '"Blosta", sans-serif', fontWeight: 400 },
    body2: { fontFamily: '"Blosta", sans-serif', fontWeight: 400 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0, 
          textTransform: 'uppercase',
          letterSpacing: 2,
          padding: '12px 24px',
          fontFamily: '"Blosta", sans-serif', 
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> 
      
      {/* A legkülső Box megakadályozza a vízszintes görgetést (fehér csík mobilon eltűnik) */}
      <Box sx={{ width: '100%', overflowX: 'hidden' }}>
        <Hero />
        
          <Welcome />
          <Program />
          <Gifts />
          <DressCode />
          <EventDetails />
          <RSVPForm />
        </Box>
        {/* ==================================================== */}

        <Footer />

      
    </ThemeProvider>
  );
}

export default App;